var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatalektDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000158002797792979650660000008273739903326805150_);fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000133515332299746285960000010645295889484388737_",
    d: "M1032.3,798.6l-18.7-18.7c-22.8-22.8-50.8-59.2-45.8-99 c5.2-41.1-8-84.1-39.5-115.7c-54.2-54.2-142-54.2-196.2,0c-54.2,54.2-54.2,142,0,196.2c31.6,31.6,74.6,44.7,115.8,39.5 c39.8-5,76.1,23,99,45.8l18.7,18.7l18.7,18.7c22.8,22.8,50.8,59.1,45.8,99c-5.2,41.1,8,84.1,39.5,115.7 c54.2,54.2,142,54.2,196.2,0c54.2-54.2,54.2-142,0-196.2C1234,871,1191,857.8,1149.9,863c-39.8,5.1-76.1-22.9-99-45.8 L1032.3,798.6z M1032.3,1480.2l-18.7-18.7c-22.8-22.8-50.8-59.1-45.8-99c5.2-41.1-8-84.1-39.5-115.7c-54.2-54.2-142-54.2-196.2,0 c-54.2,54.2-54.2,142,0,196.2c31.6,31.6,74.6,44.8,115.7,39.5c39.8-5.1,76.1,23,99,45.8l18.7,18.7l18.7,18.7 c22.8,22.8,50.8,59.1,45.8,99c-5.2,41.1,8,84.1,39.5,115.7c54.2,54.2,142,54.2,196.2,0c54.2-54.2,54.2-142,0-196.2 c-31.6-31.6-74.6-44.8-115.8-39.5c-39.8,5.1-76.1-23-99-45.8L1032.3,1480.2z M391.3,1098.7c53.2,53.2,139.5,53.2,192.7,0 c53.2-53.2,53.2-139.4,0-192.6c-53.2-53.2-139.4-53.2-192.7,0C338.1,959.3,338.1,1045.5,391.3,1098.7z M1413.8,1439.6 c53.2,53.2,139.4,53.2,192.7,0c53.2-53.2,53.2-139.5,0-192.7c-53.2-53.2-139.4-53.2-192.7,0 C1360.6,1300.1,1360.6,1386.4,1413.8,1439.6z M1374.9,456l-18.7-18.7c-22.8-22.8-50.8-59.1-45.8-99c5.2-41.1-7.9-84.1-39.5-115.7 c-54.2-54.2-142-54.2-196.2,0c-54.2,54.2-54.2,142,0,196.2c31.6,31.6,74.6,44.8,115.7,39.5c39.8-5.1,76.2,22.9,99,45.8l18.7,18.7 l18.7,18.7c22.8,22.8,50.8,59.1,45.8,99c-5.2,41.1,8,84.1,39.5,115.7c54.2,54.2,142,54.2,196.2,0c54.2-54.2,54.2-142.1,0-196.2 c-31.6-31.6-74.6-44.8-115.7-39.5c-39.8,5.1-76.1-22.9-99-45.8L1374.9,456z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170972838876704271340000009416376032637168024_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133515332299746285960000010645295889484388737_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 475.7494,
    y1: 1526.6659,
    x2: 1524.8888,
    y2: 476.1817
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#116BAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45BBCE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 338.1,
    y: 168.4,
    style: {
      clipPath: "url(#SVGID_00000170972838876704271340000009416376032637168024_)",
      fill: "url(#SVGID_1_)"
    },
    width: 1324.3,
    height: 1666.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatalektDots);
export default __webpack_public_path__ + "static/media/Datalekt_Dots.ce20ae52ceacf27bf76e6950b6ed1302.svg";
export { ForwardRef as ReactComponent };